/*global localforage  */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");

let LoadingWrap = require("ES/widgets/LoadingWrap");
let AuthedUserSession = require("../../../utils/AuthedUserSession");

let sids_I_can_manage = _.intersection(
  AuthedUserSession.getSIDsAtPackageLevel("PRO"),
  AuthedUserSession.doIHaveAccess.admin.getSIDs()
);

let getMySIDs = function (Displaylists) {
  let dl_sids = esUtils.cleanup_ids(
    _.map(Displaylists && Displaylists.perspeaker, "sid")
  );
  return _.uniq(_.intersection(dl_sids, sids_I_can_manage));
};

module.exports = dd.createClass({
  getInitialState() {
    return { selected_sid: -1 };
  },
  componentWillReceiveProps(props) {
    this.__handleDefaultSIDfromProps(props);
  },
  componentDidMount() {
    this.__handleDefaultSIDfromProps(this.props);
  },
  __handleDefaultSIDfromProps(props) {
    let { sid, Displaylists } = props;
    let my_sids = getMySIDs(Displaylists);
    let cur_sid = this.state.selected_sid;

    if (_.isEmpty(my_sids)) {
      return;
    }
    if (_.includes(my_sids, cur_sid)) {
      return; //no change needed
    }
    if (_.includes(my_sids, sid)) {
      this.__onSidChanged(sid);
      return;
    }
    sid = AuthedUserSession.getLastSelectedSID();
    sid = sid === 0 ? 1 : sid; //fix for Solution Tree to select master list
    if (_.includes(my_sids, sid)) {
      this.__onSidChanged(sid);
      return;
    }
    this.__onSidChanged(_.first(my_sids));
  },
  __onSidChanged(sid) {
    let self = this;
    localforage.setItem("actionlist_edit_id", null).then(function () {
      self.setState({ selected_sid: _.parseInt(sid) });
    }); //reset selected list for new speaker
  },
  __onCancel: esUtils.wrapPreventDefault(function () {
    if (this.props.redir) {
      radio("Hashbang_set").broadcast(this.props.redir);
    }
  }),
  render: function () {
    let { Displaylists } = this.props;
    // let {selected_sid} = this.state;

    // let onCancel = redir ? this.__onCancel : null;

    // let my_sids = getMySIDs(Displaylists);

    // let speaker;
    // if (_.includes(my_sids, selected_sid)) {
    // speaker = _.first(_.filter(Displaylists && Displaylists.perspeaker, function (spkr) {
    //   return spkr.sid === selected_sid;
    // }));
    // }

    return LoadingWrap(
      { is_loading: _.isEmpty(Displaylists), glass: true },
      dd.div(
        { className: "ActionLists" },
        dd.h2({ style: { marginTop: 0 } }, "Action Lists Have MOVED"),
        dd.p(
          { style: { marginBottom: 40 } },
          "The Master Action List screen has been moved to the main dashboard."
        ),
        dd.a(
          {
            href:
              "/dashboard/token-callback?token=" +
              _.get(AuthedUserSession, ["balboa", "estoken"], "") +
              "&redir=" +
              this.state.selected_sid +
              "/actionlist-settings",
            target: "_blank",
          },
          dd.button(
            {
              className: "btn btn-primary btn-lg",
              style: { margin: "auto" },
            },
            "Master Action List Editor"
          )
        )

        //     ProOnly({
        //         sids: AuthedUserSession.doIHaveAccess.admin.getSIDs(),
        //         custom_message: 'With a PRO account you can manage the master to-do lists for all your events.'
        //       },
        //
        //       _.size(my_sids) > 1 ? SpeakerForm({
        //         sid: selected_sid,
        //         Displaylists,
        //         sids_to_choose: my_sids,
        //         onSidChanged: this.__onSidChanged
        //       }) : null,
        //
        //       dd.div({className: "clearfix"}),
        //
        //       speaker
        //         ? MasterActionLists({
        //           speaker: speaker,
        //           Displaylists: Displaylists,
        //         })
        //         : null
        //     ),
        //     onCancel ? dd.button({
        //       className: 'btn btn-default btn-lg',
        //       onClick: onCancel
        //     }, 'Cancel') : null
      ),
      dd.div({ className: "clearfix" })
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/account_settings/action_lists/index.js